export const DEFAULT_DYNAMIC_YIELD_SECTION_ID = "8791799";
export const DYNAMIC_YIELD_CDN_ORIGIN = "https://cdn.dynamicyield.com";
